import {
    Input,
    InputGroup,
    InputLeftElement,
    InputRightElement,
} from "@chakra-ui/react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import React, { useState } from "react";
import Colors from "../../../assets/colors/Colors";

const AuthInput = (props) => {
    const [showPassword, setShowPassword] = useState(false);

    const handleToggleVisibility = () => {
        setShowPassword(!showPassword);
    };

    const isInvalid = props.inputError;

    return (
        <InputGroup>
            {props.leftIcon && (
                <InputLeftElement>{props.leftIcon}</InputLeftElement>
            )}
            <Input
                id={props.id}
                name={props.name}
                autoFocus={props.autoFocus}
                placeholder={props.placeholder}
                value={props.inputValue}
                width={props.width}
                onChange={props.handleInputChange}
                onBlur={props.handleBlur}
                onKeyDown={props.onKeyDown}
                type={showPassword ? "text" : props.type || "password"}
                variant={
                    props.darkPlaceholder
                        ? "posDarkPlaceholder"
                        : "checkoutBasicInput"
                }
                sx={{
                    fontSize: props.fontSize || "0.94rem",
                    color: Colors.posTextInfo,
                }}
                isInvalid={isInvalid}
                {...props.inputProps}
            />
            {props.showToggle && (
                <InputRightElement mr={2}>
                    {showPassword ? (
                        <VisibilityOff
                            onClick={handleToggleVisibility}
                            style={{
                                cursor: "pointer",
                                color: props.iconColor || "#5881FE33",
                                fontSize: props.iconSize || "1.3rem",
                            }}
                        />
                    ) : (
                        <Visibility
                            onClick={handleToggleVisibility}
                            style={{
                                cursor: "pointer",
                                color: props.iconColor || "#5881FE33",
                                fontSize: props.iconSize || "1.3rem",
                            }}
                        />
                    )}
                </InputRightElement>
            )}
        </InputGroup>
    );
};

export default AuthInput;
